<ng-container *ngIf="showHeader">
	<h3 class="title-main margin-bottom-20" dcrHTMLKey="MARKET_VIEWS_TITLE">BlackRock Market Views</h3>
	<section class="margin-bottom-45">
		<p dcrHTMLKey="MARKET_VIEWS_DATE">Q1 2019 Views</p>
		<p class="text-14" dcrHTMLKey="MARKET_VIEWS_DISCLOSURE">
			The views below are a synopsis of the BlackRock investment institute's latest quarterly outlook. To view the full publication, click here.
		</p>
	</section>
	<section class="text-16 market-views-summary margin-bottom-45">
		<section class="market-regime"><ul [innerHTML]="summaryItems"></ul></section>
	</section>
</ng-container>
<bfa-accordion>
	<accordion-panel [isCollapsed]="false">
		<header><span class="icon-caption panel-title" dcrHTMLKey="MARKET_VIEWS_ASSET_SECTION_HEADER">ASSET CLASS DETAIL</span></header>
		<content>
			<ng-container *ngIf="asOfDate">
				<section class="padding-bottom-5">
					<span dcrHTMLKey="MARKET_VIEW_AS_OF" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">Asset Class Views as of $asOfDate$</span>
				</section>
			</ng-container>
			<section class="row text-14 text-18-sm">
				<span class="col-4 col-md-5 col-sm-24">
					<icon type="overweight" class="category-icon overweight" width="12" height="16"></icon>
					<span dcrHTMLKey="MARKET_VIEWS_LEGEND_OVERWEIGHT">Overweight</span></span
				>
				<span class="col-4 col-md-5 col-sm-24">
					<icon type="underweight" class="category-icon underweight" width="12" height="16"></icon>
					<span dcrHTMLKey="MARKET_VIEWS_LEGEND_UNDERWEIGHT">Underweight</span></span
				>
				<span class="col-4 col-md-5 col-sm-24">
					<icon type="neutral" class="category-icon neutral" width="12" height="16"></icon> <span dcrHTMLKey="MARKET_VIEWS_LEGEND_NEUTRAL">Neutral</span></span
				>
				<span class="col-12 col-md-9">&nbsp;</span>
			</section>

			<section class="simple-table margin-standard">
				<ng-container *ngFor="let assetClass of assetClasses; index as assetIndex">
					<section class="asset-class-section">
						<section class="row asset-class-header">
							<span class="col-6 text-16-bold" [dcrHTMLKey]="assetClass">
								<span>{{ assetClass }}</span>
							</span>
						</section>
						<section class="header-row row">
							<ng-container *ngFor="let cell of allCells[assetIndex].header; index as cellIndex">
								<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
								<span class="break-long-word text-14-bold" [dcrHTMLKey]="cell" [ngClass]="getClass(cellIndex)">
									<span>{{ cell }}</span>
								</span>
							</ng-container>
						</section>

						<ng-container *ngFor="let row of allCells[assetIndex].body; index as rowIndex">
							<section class="table-row row">
								<ng-container *ngFor="let cell of row; index as cellIndex">
									<ng-container [ngTemplateOutlet]="cellIndex !== 0 ? otherCell : firstCell" [ngTemplateOutletContext]="{ cell: cell, cellIndex: cellIndex }">
										<ng-template #otherCell let-cell="cell" let-cellIndex="cellIndex">
											<span class="break-long-word" [dcrHTMLKey]="cell" [ngClass]="[getClass(cellIndex), cellIndex === 1 ? 'text-14-bold' : 'text-14']">
												<span>{{ cell }}</span>
											</span>
										</ng-template>
									</ng-container>
									<ng-template #firstCell let-cell="cell" let-cellIndex="cellIndex">
										<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
										<icon [type]="getSvgTypeAndClass(cell)" [class]="getSvgTypeAndClass(cell)" width="12" height="16" [ngClass]="getClass(0)"></icon>
									</ng-template>
								</ng-container>
							</section>
						</ng-container>
					</section>
				</ng-container>
			</section>
			<ac-disclosure><span dcrHTMLKey="OTHER_SECTION_DISCLOSURE">OTHER_SECTION_DISCLOSURE</span> </ac-disclosure>
		</content>
	</accordion-panel>
</bfa-accordion>
